export default {
  appliesToAllReports: 'Gilt für alle Berichte',
};
